import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Game, GameStateEnum } from "../../interfaces/game";

export interface GameState {
  game: Game | null;
}

const initialState: GameState = {
  game: null,
};

const gameSlice = createSlice({
  name: "gameReducer",
  initialState,
  reducers: {
    setGame: (state, action: PayloadAction<Game | null>) => {
      state.game = action.payload;
    },
    setGameId: (state, action: PayloadAction<string | null>) => {
      if (state.game) state.game.id = action.payload;
    },
    setGameState: (state, action: PayloadAction<GameStateEnum>) => {
      if (state.game) state.game.state = action.payload;
    },
  },
});

export const { setGame, setGameId, setGameState } = gameSlice.actions;
export default gameSlice.reducer;
